import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import styled from 'styled-components';
import Colors from '@components/shared/Colors';
import { TEXT_STYLES, TextVariant, Typography } from '@components/shared/design/Typography';
import NewsletterFormAlt from '@components/shared/NewsletterFormAlt';
import TwoColumn from '@components/shared/TwoColumn';
import { HORMONAL_TESTING_FOUNDERS_RESULTS_IMG, MEDIA } from '@constants';
import useTranslate from '@hooks/useTranslate';

const HTFoundersResults: React.FC = () => {
  const { t } = useTranslate();
  const KLAVIYO_LIST_ID = 'YfMGdW';

  return (
    <Container>
      <Inner>
        <TwoColumn gap="120px" gapMobile="16px" mobileReverse={true} breakpoint="1024px" alignment="center">
          <TextWrap>
            <Typography $variant={TextVariant.Heading5} $mobileVariant={TextVariant.Heading7}>
              {t('components.peek-into-founders-results')}
            </Typography>
            <Typography $variant={TextVariant.BodyRegularLG} $mobileVariant={TextVariant.BodyRegularMD}>
              {t('components.ht-founders-results-description')}
            </Typography>
            <NewsletterFormAlt listId={KLAVIYO_LIST_ID} />
            <HintText>{t('components.waitlist-promotions-agreed')}</HintText>
          </TextWrap>
          <StyledImg src={HORMONAL_TESTING_FOUNDERS_RESULTS_IMG} alt="Hormonal Testing Founders Results" fetchpriority="low" />
        </TwoColumn>
      </Inner>
    </Container>
  );
};

export default HTFoundersResults;

const Container = styled.div`
  padding: 56px;
  background: linear-gradient(180deg, #eae9f9 0%, #fdf3de 100%), linear-gradient(180deg, #eae9f9 0%, rgba(234, 233, 249, 0.5) 100%),
    linear-gradient(0deg, #fdf3de 0%, #fdf3de 100%), #eae9f9;

  ${MEDIA.laptop} {
    background: none;
    padding: 16px;
  }
`;

const Inner = styled.div`
  width: 90vw;

  ${MEDIA.laptop} {
    width: auto;
    padding: 16px;
    border-radius: 12px;
    background: linear-gradient(180deg, #eae9f9 0%, rgba(234, 233, 249, 0.5) 100%), linear-gradient(0deg, #fdf3de 0%, #fdf3de 100%), #eae9f9;
  }
`;

const TextWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0;
  gap: 20px;
  max-width: 500px;
  color: ${Colors.navyBlue};

  ${MEDIA.laptop} {
    gap: 16px;
  }
`;

const HintText = styled.p`
  ${TEXT_STYLES[TextVariant.BodyRegularSM]};
  color: ${Colors.navyBlue};
  opacity: 0.6;
`;

const StyledImg = styled(LazyLoadImage)`
  height: 100%;
  max-width: 50%;
  min-height: 300px;
  width: auto;
  object-fit: cover;
  overflow: visible;

  ${MEDIA.laptop} {
    max-width: 100%;
    max-height: 460px;
    min-height: auto;
  }
`;
